<div class="billing-container" [class.no-header-info]="!showHeaderInfo">
  <ng-container *ngIf="showHeaderInfo">
    <app-billing-section-header></app-billing-section-header>
  </ng-container>
  <ng-container *ngIf="(hasDefaultBilling$ | async) === false; else billingData">
    <ng-container *ngIf="!!(billingInfo$ | async | billingCollection | async)?.length; else addNewBilling">
      <ng-container *ngTemplateOutlet="addBillingByOptions"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="billingErrorMessage$ | async as billingErrorMessage">
    <div class="billing-error">
      <span class="only-error">
        {{ 'BOOKING_MODULE.BILLING.' + billingErrorMessage | transloco }}
      </span>
    </div>
  </ng-container>
</div>

<app-swipe-up
  [height]="95"
  (toggleShowSwipeUp)="toggleOptions()"
  [showSwipeUp]="showSwipeUpOptions"
  [showHeader]="true"
  [title]="'BOOKING_MODULE.BILLING.EMIT_BILL' | transloco"
  [subTitle]="'BOOKING_MODULE.BILLING.BILLING_SUBTITLE' | transloco">
  <ng-container content>
    <div class="content">
      <ng-container *ngTemplateOutlet="billingOptions"></ng-container>
    </div>
  </ng-container>
</app-swipe-up>

<ng-container *ngIf="showBillingOptions">
  <app-modal
    [width]="640"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.BILLING.EMIT_BILL' | transloco"
    [subTitle]="'BOOKING_MODULE.BILLING.BILLING_SUBTITLE' | transloco"
    (toggleModal)="toggleOptions()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="billingOptions"></ng-container>
    </ng-container>
  </app-modal>
</ng-container>

<ng-template #billingOptions>
  <ng-container *ngIf="billingInfo$ | async as billingInfo">
    <app-billing-options-saved
      [options]="billingInfo | billingCollection | async"
      [isInvalidContactInfo]="isInvalidContactInfo"
      (toggleList)="doubleToggle()"
      (edit)="updateBillingOption($event)"
      (selectBilling)="selectBillingOption($event)"
      (remove)="deleteOption($event)">
    </app-billing-options-saved>
  </ng-container>
</ng-template>

<app-billing-form
  #billingFormRef
  [cities]="cities"
  [countries]="countries"
  [user]="user"
  [formRef]="bookingForm"
  [userAddresses]="userAddresses$ | async"
  [firstPaxSelection]="firstPaxSelection$ | async"
  [defaultBilling]="defaultBilling"
  [businessRules]="businessRules$ | async"
  [bookingType]="bookingType$ | async"
  [withErrorLaunch]="withErrorLaunch$ | async"
  [showSwipeUpForm]="showSwipeUpForm"
  [isMobile]="isMobile"
  (closeForm)="close()"
  (toggleShowForm)="toggleForm()"
  (update)="updateBillingInfo($event)"
  (create)="createBillingInfo($event)">
</app-billing-form>

<ng-template #addBillingByOptions>
  <app-new-billing-data
    [icon]="icons.ChevronRight"
    [isDisabled]="isInvalidContactInfo"
    [showError]="hasBillingError$ | async"
    (toggleList)="toggleOptions()">
  </app-new-billing-data>
</ng-template>

<ng-template #billingData>
  <div class="billing__edit" *ngIf="lastBillingUI$ | async">
    <div class="billing__edit--icon">
      <app-ds-icon
        [icon]="icons.EditOutline"
        [size]="14">
      </app-ds-icon>
    </div>
    <app-ds-typography
      [size]="typographyFontSize.XXXS"
      [tag]="'p'"
      [color]="typographyColor.Secondary"
      [text]="'BOOKING_MODULE.BILLING.PROFILE' | transloco">
    </app-ds-typography>
    <div class="billing__edit--action">
      <app-ds-typography
        [size]="typographyFontSize.XXXS"
        [tag]="'p'"
        [color]="typographyColor.Highlight"
        [textDecoration]="'underline'"
        [text]="'BOOKING_MODULE.BILLING.CHANGE' | transloco"
        (click)="toggleOptions()">
      </app-ds-typography>
    </div>
  </div>
  <ng-container *ngIf="defaultBilling$ | async as defaultData">
    <app-ds-data-action-card
      [info]="[
        {
          Type: dataActionCardInfoType.Data,
          Title: defaultData.billing_info?.natural_person ? (defaultData.billing_info?.first_name + ' ' + defaultData?.billing_info?.last_name) : defaultData.billing_info?.legal_name,
          Subtitle: (documentDefaultBilling$(defaultData) | async) + ': ' + defaultData?.billing_info?.document_number,
          DataIcon: defaultData.billing_info?.natural_person ? icons.PersonOutline : icons.WorkOutline,
          ActionIcon: icons.ChevronRight
        }
      ]"
      (clickEvent)="toggleOptions()">
    </app-ds-data-action-card>
  </ng-container>
</ng-template>

<ng-template #addNewBilling>
  <app-new-billing-data
    [icon]="icons.Add"
    [isDisabled]="isInvalidContactInfo"
    [showError]="hasBillingError$ | async"
    (toggleList)="toggleForm()">
  </app-new-billing-data>
</ng-template>